module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-head",
    attrs: {
      "id": "Ack"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("I would like to thank the Library of Congress for making its collection of Civil War images, documents, and maps available to the public. It is a fascinating experience moving back and forth in time through the various collections so wonderfully preserved. I would also like to thank Caroline (Anderson) Vickerson at Arcadia Publishing for guiding me through the production of this book.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1789404b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgements.vue
// module id = 75
// module chunks = 0